import { Button } from '@repo/ui/button'
import { CommandShortcut } from '@repo/ui/command'
import { useT } from '@repo/ui/hooks'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@repo/ui/sheet'
import { XIcon } from 'lucide-react'
import { ReactNode, useState } from 'react'

import { BeneficiaryListWithFiltersAndPagination } from '@/components/beneficiary/list/BeneficiaryListWithFiltersAndPagination'
import { Description } from '@/components/beneficiary/list/Description'
import {
  BeneficiaryListAsSheetContext,
  BeneficiaryListAsSheetOptions,
} from '@/components/beneficiary/list/sheet/context'
import { reset, setCurrentFilterTemplate } from '@/store/beneficiary-list-filters/slice'
import { useStoreDispatch } from '@/store/hooks'

export function BeneficiaryListAsSheetProvider({ children }: { children: ReactNode }) {
  const dispatch = useStoreDispatch()
  const { t, tc } = useT({ keyPrefix: 'dashboard.beneficiaryList' })
  const [open, setOpen] = useState(false)
  const [sheetChildren, setSheetChildren] = useState<ReactNode>(null)
  const handleSetOpen = (open: boolean, options?: BeneficiaryListAsSheetOptions) => {
    if (open) {
      if (options) {
        if (options.filterTemplate) {
          dispatch(setCurrentFilterTemplate(options.filterTemplate))
        }
        if (options.children) {
          setSheetChildren(options.children)
        }
      }
    } else {
      setSheetChildren(null)
      dispatch(reset())
    }
    setOpen(open)
  }
  return (
    <BeneficiaryListAsSheetContext.Provider value={{ open, setOpen: handleSetOpen }}>
      <Sheet open={open} onOpenChange={handleSetOpen}>
        <SheetContent
          side="bottom"
          className="h-full"
          close={
            <Button variant="secondary" className="mx-2">
              <div className="text-primary-500 hover:text-primary scale-100 hover:scale-110 transition-all duration-300">
                <XIcon className="size-4" />
              </div>
              {tc('close', { cfl: true })}
              <CommandShortcut className="bg-primary-50 rounded-md px-1 pb-0.5 border border-primary-200 tracking-tight">
                esc
              </CommandShortcut>
            </Button>
          }
        >
          {sheetChildren ? (
            sheetChildren
          ) : (
            <>
              <SheetHeader className="px-0">
                <SheetTitle>{t('title')}</SheetTitle>
                <SheetDescription>
                  <Description />
                </SheetDescription>
              </SheetHeader>
              <BeneficiaryListWithFiltersAndPagination onSelectBeneficiary={() => setOpen(false)} />
            </>
          )}
        </SheetContent>
      </Sheet>

      {children}
    </BeneficiaryListAsSheetContext.Provider>
  )
}
